
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { saveProviderToken } from "@/utils/emailUtils";
import { toast } from "sonner";
import { EmailProvider } from "@/types/email";

interface GmailProviderSetupProps {
  provider?: EmailProvider;
  onUpdate: () => void;
}

const GmailProviderSetup = ({ provider, onUpdate }: GmailProviderSetupProps) => {
  const [gmailToken, setGmailToken] = useState("");
  
  const handleSaveToken = () => {
    if (!gmailToken.trim()) {
      toast.error("Please enter a Gmail API token");
      return;
    }
    
    saveProviderToken("gmail", gmailToken);
    toast.success("Gmail API token saved");
    setGmailToken("");
    onUpdate();
  };
  
  return (
    <div className="space-y-4">
      {provider?.isConnected && (
        <Alert>
          <AlertDescription>
            Gmail is connected. Last updated: {
              provider.lastTokenUpdate 
                ? new Date(provider.lastTokenUpdate).toLocaleString() 
                : "Unknown"
            }
          </AlertDescription>
        </Alert>
      )}
      
      <div className="space-y-2">
        <label className="text-sm font-medium">Gmail API Token</label>
        <Input
          type="password"
          value={gmailToken}
          onChange={(e) => setGmailToken(e.target.value)}
          placeholder="Enter your Gmail API token"
        />
        <p className="text-xs text-muted-foreground">
          Your token will be stored locally in your browser only
        </p>
      </div>
      
      <Button onClick={handleSaveToken} className="w-full">
        {provider?.isConnected ? "Update Gmail Connection" : "Connect Gmail"}
      </Button>
    </div>
  );
};

export default GmailProviderSetup;
